import RequestService from "@/configurations/AxiosConfig";

const endpoints = {
  reports: 'reports',
  customerReports: 'reports/customerId',
  getUsersByReportId: 'reports/getUsersByReportId',
  getReportTypes: 'reports/getReportTypes',
};

const ReportsService = {
  getReportsByCustomerId: (id: string | number) => RequestService.get(`${endpoints.customerReports}/${id}`),
  getReportTypes: () => RequestService.get(`${endpoints.getReportTypes}`),
  getReportsByReportId: (id: string | number) => RequestService.get(`${endpoints.reports}/${id}`),
  getUsersByReportId: (id: string | number) => RequestService.get(`${endpoints.getUsersByReportId}/${id}`),
  createReport: (data: FormData) => RequestService.post(endpoints.reports, data),
};

export default ReportsService;
